import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { IServiceOrganizationSettingFormSectionProps } from '../ServiceOrganizationSetting';
import { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { SomnologyOrganizationType } from '../../../../../../common/enums/somnologyOrganizationType';
import { translateKey } from '../../../../../translate';
import { EnumDropdownInput } from '../../../../fields/EnumDropdown';
import { ServiceOrganizationSettingFormMode } from '../ServiceOrganizationSetting';

export function SomnologyOrganizationTypeFormSection(props: IServiceOrganizationSettingFormSectionProps) {
    if (
        ![ServiceCode.OSASO, ServiceCode.OSASVO, ServiceCode.OSASV].includes(props.service.code) ||
        !props.hasServiceProviders
    ) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceOrganizationSetting.somnologyOrganizationType')}>
            <FormGroup label={translateKey('serviceOrganizationSetting.somnologyOrganizationType')}>
                {props.mode === ServiceOrganizationSettingFormMode.read ? (
                    <FormParagraph>
                        {props.somnologyOrganizationType
                            ? translateKey(`somnologyOrganizationTypeEnum.${props.somnologyOrganizationType}`)
                            : '-'}
                    </FormParagraph>
                ) : (
                    <EnumDropdownInput
                        enumName="somnologyOrganizationType"
                        error={props.errors.get('somnologyOrganizationType')}
                        fieldKey="somnologyOrganizationType"
                        jsEnum={SomnologyOrganizationType}
                        newstyles
                        placeholder={translateKey('serviceOrganizationSetting.selectSomnologyOrganizationType')}
                    />
                )}
            </FormGroup>
        </FormSection>
    );
}
